var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCurtain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;stroke:#000000;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:#000000;stroke-miterlimit:10;}\r\n\t.st2{fill:none;stroke:#000000;stroke-width:0.5;stroke-miterlimit:10;}\r\n\t.st3{opacity:0.75;fill:#E6E6E6;stroke:#000000;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "15.23,51.92 13.36,53.51 13.36,74.51 84.32,90.68 86.5,88.5 86.5,68.25  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "13.11,54.34 84.11,70.6 86.5,68.25  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 84.53,
    y1: 90.47,
    x2: 84.53,
    y2: 69.8
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "13.36,7.33 13.36,74.51 84.03,90.47 84.03,23.47  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M13.67,7.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M84.53,23.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M84.53,37.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "13.36,7.33 84.03,23.47 84.03,90.47 13.36,74.51  "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 35.55,
    y1: 12.36,
    x2: 35.55,
    y2: 79.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 60.93,
    y1: 18.18,
    x2: 60.93,
    y2: 85.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 13.11,
    y1: 54.34,
    x2: 84.11,
    y2: 70.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCurtain);
export default __webpack_public_path__ + "static/media/IconCurtain.4c6138d42385854ba0bbc38940e3f269.svg";
export { ForwardRef as ReactComponent };